import { DayEntry, Task, Timestamp } from '@griply/types';
import { getSlotVariants, SlotVariant } from '@griply/utils';
import React from 'react';
import { useToday } from 'shared/contexts/today';

import { AddSlot } from './add-slot';
import { EntrySlot } from './entry-slot';
import { UntilCompletedSlot } from './until-completed-slot';

export type UpcomingSlotProps = {
  task: Task;
  date: Timestamp;
  entry?: DayEntry;
  isOverdue?: boolean;
};

export const UpcomingSlot: React.FC<UpcomingSlotProps> = ({
  task,
  date,
  entry,
}) => {
  const today = useToday();
  const variants = getSlotVariants(entry, date, today);

  return (
    <>
      {variants.map((variant) => {
        if (variant === SlotVariant.Entry && entry) {
          return (
            <EntrySlot key="entry" task={task} date={date} entry={entry} />
          );
        }
        if (variant === SlotVariant.Add && !entry) {
          return <AddSlot key="add" task={task} date={date} />;
        }
        if (variant === SlotVariant.UntilCompleted && entry) {
          return (
            <UntilCompletedSlot
              key="until-completed"
              task={task}
              date={date}
              entry={entry}
            />
          );
        }
        return null;
      })}
    </>
  );
};
